import DataTable from '../DataTable';
import { Bones } from '@simplywallst/ui-core';

const RecentlyViewedSkeleton = () => (
  <DataTable
    columnWidths="6,2,2"
    columnTextAlignments="l,r,r"
    disabled={true}
    data-cy-id="dashboard-recently-viewed-skeleton"
  >
    <thead>
      <tr>
        <th>Symbol</th>
        <th>7D</th>
        <th>1Y</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>
          <span>
            <Bones />
          </span>
        </td>
        <td>
          <span>
            <Bones />
          </span>
        </td>
        <td>
          <span>
            <Bones />
          </span>
        </td>
      </tr>
    </tbody>
  </DataTable>
);

export default RecentlyViewedSkeleton;
